var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "core-icon",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M13.583,16.111H8.528A2.531,2.531,0,0,1,6,13.583V8.528A2.531,2.531,0,0,1,8.528,6h5.056a2.531,2.531,0,0,1,2.528,2.528v5.056A2.531,2.531,0,0,1,13.583,16.111ZM8.528,8.167a.362.362,0,0,0-.361.361v5.056a.362.362,0,0,0,.361.361h5.056a.362.362,0,0,0,.361-.361V8.528a.362.362,0,0,0-.361-.361Z",
    transform: "translate(0 0)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M35.583,16.111H30.528A2.531,2.531,0,0,1,28,13.583V8.528A2.531,2.531,0,0,1,30.528,6h5.056a2.531,2.531,0,0,1,2.528,2.528v5.056A2.531,2.531,0,0,1,35.583,16.111ZM30.528,8.167a.362.362,0,0,0-.361.361v5.056a.362.362,0,0,0,.361.361h5.056a.362.362,0,0,0,.361-.361V8.528a.362.362,0,0,0-.361-.361Z",
    transform: "translate(-6.111 0)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M13.583,38.111H8.528A2.531,2.531,0,0,1,6,35.583V30.528A2.531,2.531,0,0,1,8.528,28h5.056a2.531,2.531,0,0,1,2.528,2.528v5.056A2.531,2.531,0,0,1,13.583,38.111ZM8.528,30.167a.362.362,0,0,0-.361.361v5.056a.362.362,0,0,0,.361.361h5.056a.362.362,0,0,0,.361-.361V30.528a.362.362,0,0,0-.361-.361Z",
    transform: "translate(0 -6.111)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M35.583,38.111H30.528A2.531,2.531,0,0,1,28,35.583V30.528A2.531,2.531,0,0,1,30.528,28h5.056a2.531,2.531,0,0,1,2.528,2.528v5.056A2.531,2.531,0,0,1,35.583,38.111Zm-5.056-7.944a.362.362,0,0,0-.361.361v5.056a.362.362,0,0,0,.361.361h5.056a.362.362,0,0,0,.361-.361V30.528a.362.362,0,0,0-.361-.361Z",
    transform: "translate(-6.111 -6.111)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_178",
    "data-name": "Line 178",
    d: "M1.75.667H-.417A1.083,1.083,0,0,1-1.5-.417,1.083,1.083,0,0,1-.417-1.5H1.75A1.083,1.083,0,0,1,2.833-.417,1.083,1.083,0,0,1,1.75.667Z",
    transform: "translate(15.444 10.389)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_179",
    "data-name": "Line 179",
    d: "M1.75.667H-.417A1.083,1.083,0,0,1-1.5-.417,1.083,1.083,0,0,1-.417-1.5H1.75A1.083,1.083,0,0,1,2.833-.417,1.083,1.083,0,0,1,1.75.667Z",
    transform: "translate(21.222 10.389)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_180",
    "data-name": "Line 180",
    d: "M-.417,2.833A1.083,1.083,0,0,1-1.5,1.75V-.417A1.083,1.083,0,0,1-.417-1.5,1.083,1.083,0,0,1,.667-.417V1.75A1.083,1.083,0,0,1-.417,2.833Z",
    transform: "translate(10.389 21.222)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_181",
    "data-name": "Line 181",
    d: "M-.417,2.833A1.083,1.083,0,0,1-1.5,1.75V-.417A1.083,1.083,0,0,1-.417-1.5,1.083,1.083,0,0,1,.667-.417V1.75A1.083,1.083,0,0,1-.417,2.833Z",
    transform: "translate(10.389 15.444)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_182",
    "data-name": "Line 182",
    d: "M1.75.667H-.417A1.083,1.083,0,0,1-1.5-.417,1.083,1.083,0,0,1-.417-1.5H1.75A1.083,1.083,0,0,1,2.833-.417,1.083,1.083,0,0,1,1.75.667Z",
    transform: "translate(21.222 28.444)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_183",
    "data-name": "Line 183",
    d: "M1.75.667H-.417A1.083,1.083,0,0,1-1.5-.417,1.083,1.083,0,0,1-.417-1.5H1.75A1.083,1.083,0,0,1,2.833-.417,1.083,1.083,0,0,1,1.75.667Z",
    transform: "translate(15.444 28.444)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_184",
    "data-name": "Line 184",
    d: "M-.417,2.833A1.083,1.083,0,0,1-1.5,1.75V-.417A1.083,1.083,0,0,1-.417-1.5,1.083,1.083,0,0,1,.667-.417V1.75A1.083,1.083,0,0,1-.417,2.833Z",
    transform: "translate(28.444 15.444)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_185",
    "data-name": "Line 185",
    d: "M-.417,2.833A1.083,1.083,0,0,1-1.5,1.75V-.417A1.083,1.083,0,0,1-.417-1.5,1.083,1.083,0,0,1,.667-.417V1.75A1.083,1.083,0,0,1-.417,2.833Z",
    transform: "translate(28.444 21.222)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreIcon);
export default __webpack_public_path__ + "static/media/core-icon.a5b405c556b81f4f1f3cb0ebc632a15c.svg";
export { ForwardRef as ReactComponent };